import script from "./ComicTipDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ComicTipDialog.vue?vue&type=script&setup=true&lang=js"

import "@/features/comic/styles/ComicTipDialog.css?vue&type=style&index=0&id=03084830&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03084830"]])

export default __exports__